import { useWidgetContext } from '../../../hooks/use-widget-context';
import { Page } from '../../../types/constants';
export const useNavigation = () => {
    const { onBack, displayPanel, setDisplayPanel, startView } = useWidgetContext();
    const handleBackToVoipPage = (calling) => {
        if (startView === Page.OtherContacts) {
            onBack?.(calling);
            return;
        }
        setDisplayPanel(Page.Voip);
    };
    const mapperHandleBack = {
        [Page.Voip]: onBack,
        [Page.OtherContacts]: handleBackToVoipPage,
    };
    const handleBackClick = mapperHandleBack[displayPanel];
    return {
        handleBackClick,
    };
};
